<template>
  <div>
    <b-row class="mb-3 text-center">
      <b-col lg="12">
        <h2 class="font-size-16">Dziekujęmy za udział w egzaminie</h2>
      </b-col>
      <b-col lg="12 pb-lg-3">
        <strong class="color-green font-size-20"
          >Gratulujemy! Twój Test został zaliczony</strong
        >
      </b-col>
      <b-col lg="12">
        <b-row>
          <div class="bg-white rounded-circle topImage p-3 pt-4 pl-4 m-auto">
            <b-img class="m-auto" :src="styles.course_dyplom_xl" fluid></b-img>
          </div>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="2" class="ml-auto">
            <b-row class="text-center color-green"
              ><div class="m-auto font-weight-bold color-green font-size-28">
                {{ examResults.correct }}
              </div></b-row
            >
            <b-row class="text-center"
              ><div class="m-auto">Odpowiedzi poprawne</div></b-row
            >
          </b-col>
          <b-col lg="2" class="mr-auto">
            <b-row class="text-center"
              ><div class="m-auto font-weight-bold color-red font-size-28">
                {{ examResults.invalid }}
              </div></b-row
            >
            <b-row> <div class="m-auto">Odpowiedzi niepoprawne</div></b-row>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col class="">
            <div class="m-auto w-100 text-left">
              <b-card
                bg-variant="light"
                header="Wystawiono certyfikat dla:"
                class="m-auto max-wd-490"
              >
                <b-card-text class="d-flex flex-row p-3"
                  ><div class="ml-0 font-size-24">
                    {{ participantName }}
                  </div>
                  <b-button
                    v-on:click="onPrintCertificate"
                    class="
                      btn-accept-color
                      mr-0
                      ml-auto
                      my-auto
                      font-size-16
                      p-2
                    "
                  >
                    <b-icon-download /> Pobierz certyfikat</b-button
                  >
                </b-card-text>
              </b-card>
            </div>
          </b-col>
        </b-row>
        <b-row> </b-row>
        <b-row class="mt-4">
          <b-col lg="2" class="m-auto">
            <b-button
              class="btn mr-0 ml-auto my-auto font-size-16 p-2"
              v-on:click="$emit('showCourse')"
            >
              <b-icon-box-arrow-left /> Wróć do Kursu</b-button
            ></b-col
          >
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CourseExamPassed',
  data() {
    return {};
  },
  props: {
    styles: {},
    examResults: {},
    participantName: {},
    participantId: {},
  },
  computed: {
    ...mapGetters({
      licence: 'auth/userLicence',
    }),
  },
  created() {
    window.dataLayer.push({
      event: 'btnTestWynikPozytywny',
      user_id: this.participantId,
      license_id: this.licence,
    });
  },
  methods: {
    onPrintCertificate() {
      window.dataLayer.push({
        event: 'btnPobierzCertyfikat',
        user_id: this.participantId,
        license_id: this.licence,
      });
      window.open(
        '/api/course-exam/print-certificate/' + this.participantName,
        '_blank'
      );
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .topImage {
    width: 140px;
    height: 140px;
  }
}
</style>
